// extracted by mini-css-extract-plugin
export default {"main":"LiveScore_main__aD8U9"};